import axiosInstance from "../../../Utils/axiosInstance";
import { BASE_URL } from "../../../Utils/config";

const TOKEN_URL = { BASE_URL } + "/api/refresh";

interface Payload {
    email: string;
    otp: number;
}

const varifyOtpApi = async (payload: Payload) => {
    try {
        let token = localStorage.getItem("accessToken");

        const response = await axiosInstance.post(
            "/api/mm_manager/otp/verifyOtp",
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response?.data;
    } catch (error: any) {
        // If unauthorized, try refreshing token
        if (error?.response?.status === 401) {
            const refreshToken = localStorage.getItem("refreshToken");

            try {
                const refreshRes = await axiosInstance.post(
                    TOKEN_URL,
                    { refreshToken },
                    {
                        headers: { "Content-Type": "application/json" }
                    }
                );

                if (refreshRes?.status === 200) {
                    const { accessToken } = refreshRes.data;
                    localStorage.setItem("accessToken", accessToken);

                    // retry original request with new token
                    const retryResponse = await axiosInstance.post(
                        "/api/mm_manager/otp/verifyOtp",
                        payload,
                        {
                            headers: {
                                Authorization: `Bearer ${accessToken}`
                            }
                        }
                    );
                    return retryResponse?.data;
                } else {
                    alert("Session expired, please log in again.");
                    window.location.href = "/login";
                }
            } catch (refreshError) {
                alert("Session expired, please log in again.");
                window.location.href = "/login";
            }
        }
        return error?.response?.data;
    }
};

export default varifyOtpApi;
